import { render, staticRenderFns } from "./PopupFence.vue?vue&type=template&id=08feb4d4&scoped=true&"
import script from "./PopupFence.vue?vue&type=script&lang=js&"
export * from "./PopupFence.vue?vue&type=script&lang=js&"
import style0 from "./PopupFence.vue?vue&type=style&index=0&id=08feb4d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08feb4d4",
  null
  
)

export default component.exports